import React from 'react'
import type { SelectionMode } from './ThreeStateHeaderCheckbox'
import styles from './SelectionBanner.module.scss'

interface Props {
  selectionMode: SelectionMode
  selectedCount: number
  totalCount: number
  isMultiPage: boolean
  onSelectAll: () => void
  onClearSelection: () => void
}

export default function SelectionBanner({
  selectionMode,
  selectedCount,
  totalCount,
  isMultiPage,
  onSelectAll,
  onClearSelection,
}: Props) {
  if (selectionMode === 'none') return null

  if (selectionMode === 'all') {
    return (
      <div className={styles.banner}>
        <span>
          All {totalCount} items selected across all pages.{' '}
          <button
            type="button"
            className={styles.link}
            onClick={onClearSelection}
          >
            Clear selection
          </button>
        </span>
      </div>
    )
  }

  return (
    <div className={styles.banner}>
      <span>
        {selectedCount} item{selectedCount !== 1 ? 's' : ''} selected
        {isMultiPage ? ' on this page' : ''}.{' '}
        {isMultiPage && (
          <button type="button" className={styles.link} onClick={onSelectAll}>
            Select all {totalCount} items
          </button>
        )}
      </span>
    </div>
  )
}
